// extracted by mini-css-extract-plugin
export var closeButton = "_h2-2";
export var closeButtonIcon = "_h2-3";
export var lightboxContent = "_h2-1";
export var lightboxOverlay = "_h2-0";